"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SnowplowGoogleTagManagerScript_1 = __importDefault(require("./SnowplowGoogleTagManagerScript"));
exports.default = SnowplowGoogleTagManagerScript_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcmVhY3QvZ29vZ2xlVGFnTWFuYWdlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNHQUE4RTtBQUc5RSxrQkFBZSx3Q0FBOEIsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/react/googleTagManager/index.ts